export enum TrackedEvent {
  NoteView = "note_view",
  NotesView = "notes_view",
  ImportedNotesView = "imported_notes_view",
  ImportViaCreateNote = "import_via_create_note",
  ImportViaUserProfileMenu = "import_via_user_profile_menu",
  NoteCreate = "note_create",
  NoteAddToCollection = "note_add_to_collection",
  NoteShare = "note_share",
  TemplateCreate = "template_create",
  TemplateUsed = "template_used",
  TemplateView = "template_view",
  TemplatesView = "templates_view",
  CollectionView = "collection_view",
  CollectionsView = "collections_view",
  ImportedCollectionsView = "imported_collections_view",
  CollectionCreate = "collection_create",
  CollectionShare = "collection_share",
  TemplateShare = "template_share",
  ChatView = "chat_view",
  ChatCreate = "chat_create",
  ChatCreateFromConversationTooLong = "chat_create_from_conversation_too_long",
  ChatResume = "chat_resume",
  ChatSelect = "chat_select",
  ChatMessageSend = "chat_message_send",
  ChatMessageSendFromSuggestion = "chat_message_send_from_suggestion",
  ChatMessageUpvote = "chat_message_upvote",
  ChatMessageDownvote = "chat_message_downvote",
  ChatInputLookAtClick = "chat_input_look_at_click",
  ChatInputAgentModeToggle = "chat_input_agent_mode_toggle",
  ChatInputContextAdd = "chat_input_context_add",
  ChatInputContextRemove = "chat_input_context_remove",
  SearchView = "search_view",
  SearchResultsOpenNote = "search_results_open_note",
  SearchResultsOpenCollection = "search_results_open_collection",
  QuickSearchView = "quick_search_view",
  QuickSearchOpenCollection = "quick_search_open_collection",
  QuickSearchOpenNote = "quick_search_open_note",
  CopilotOpenNote = "copilot_open_note",
  CopilotUpvoteNote = "copilot_upvote_note",
  CopilotDownvoteNote = "copilot_downvote_note",
  ImportFrom1Dot0StartImport = "import_from_1_dot_0_start_import",
  ExportCreate = "export_create",
  PerformanceHeartbeat = "performance_heartbeat",
  SyncErrorShown = "sync_error_shown",
  AppCalloutBannerActionClicked = "app_callout_banner_action_clicked",
  AppCalloutBannerDismissed = "app_callout_banner_dismissed",
  PerformanceBootstrap = "performance_bootstrap",
  AppStoreInitErrorShown = "app_store_init_error_shown",
  ImportFilesDropped = "import_files_dropped",
  ImportFilesBatchStarted = "import_files_batch_started",
  ImportFilesBatchFailed = "import_files_batch_failed",

  // Email Capture Events
  EmailConnect = "email_connect",
  EmailDisconnect = "email_disconnect",
  EmailFormattingModeSelect = "email_formatting_mode_select",
  EmailFormattingSmartModeCustomize = "email_formatting_smart_mode_customize",
  EmailOrganizingModeChecked = "email_organizing_mode_checked",
  EmailOrganizingModeUnchecked = "email_organizing_mode_unchecked",
  EmailOrganizingSpecificCollectionsSaved = "email_organizing_specific_collections_saved",
  EmailOrganizingSmartModeCustomize = "email_organizing_smart_mode_customize",

  // Text Message Events
  TextFormattingModeSelect = "text_formatting_mode_select",
  TextFormattingSmartModeCustomize = "text_formatting_smart_mode_customize",
  TextOrganizingModeChecked = "text_organizing_mode_checked",
  TextOrganizingModeUnchecked = "text_organizing_mode_unchecked",
  TextOrganizingSpecificCollectionsSaved = "text_organizing_specific_collections_saved",
  TextOrganizingSmartModeCustomize = "text_organizing_smart_mode_customize",

  // API Request Events
  ApiKeyCreate = "api_key_create",
  ApiKeyName = "api_key_name",
  ApiKeyDelete = "api_key_delete",
  ApiDevDocsLinkClick = "api_dev_docs_link_click",

  // Zapier Events
  ZapierIntegrationLinkClick = "zapier_integration_link_click",
  ZapierDisconnect = "zapier_disconnect",

  // Voice Session Events
  VoiceSessionStart = "voice_session_start",
  VoiceSessionPause = "voice_session_pause",
  VoiceSessionResume = "voice_session_resume",
  VoiceSessionDone = "voice_session_done",
  VoiceSessionSuggestedEditsView = "voice_session_suggested_edits_view",
  VoiceSessionSuggestedEditsRefine = "voice_session_suggested_edits_refine",
  VoiceSessionSuggestedEditsAccept = "voice_session_suggested_edits_accept",
  VoiceSessionSuggestedEditsReject = "voice_session_suggested_edits_reject",
  VoiceRecordingView = "voice_recording_view",
  VoiceRecordingAudioPlay = "voice_recording_audio_play",
  VoiceRecordingTranscriptScroll = "voice_recording_transcript_scroll",
  DesktopSystemAudioPermissionsModalView = "desktop_system_audio_permissions_modal_view",
  DesktopSystemAudioPermissionInteract = "desktop_system_audio_permission_interact",
  DesktopSystemAudioPermissionOpenPreferences = "desktop_system_audio_permission_open_preferences",
  DesktopSystemAudioPermissionsRestartClick = "desktop_system_audio_permissions_restart_click",

  // Note Cleanup Events
  NoteCleanupStart = "note_cleanup_start",
  NoteCleanupRefine = "note_cleanup_refine",
  NoteCleanupAccept = "note_cleanup_accept",
  NoteCleanupReject = "note_cleanup_reject",

  // Welcome & Onboarding
  WelcomeOverlayView = "welcome_overlay_view",
  IcpRfiStepComplete = "icp_rfi_step_complete",
  ReferrerStepComplete = "referrer_step_complete",

  ImportCtaView = "import_cta_view",
  ImportWizardView = "import_wizard_view",
  ImportWizardAppSelect = "import_wizard_app_select",
  ImportWizardSkip = "import_wizard_skip",
  ImportWizardStepChange = "import_wizard_step_change",
  ImportWizardComplete = "import_wizard_complete",

  // Multi-Tab Events
  PaneSplit = "pane_split",
  TabOpen = "tab_open",
  TabView = "tab_view",

  //Chrome Extension
  ChromeExtensionOnboardingInstallerView = "chrome_extension_onboarding_installer_view",
  ChromeExtensionOnboardingInstallerClick = "chrome_extension_onboarding_installer_click",
  ChromeExtensionHomeCarouselInstallerClick = "chrome_extension_home_carousel_installer_click",
  ChromeExtensionCustomInstructionsSave = "chrome_extension_custom_instructions_save",

  // Session Chat
  ChatSessionMessageSend = "chat_session_message_send",
  ChatSessionMessageUpvote = "chat_session_message_upvote",
  ChatSessionMessageDownvote = "chat_session_message_downvote",

  // Monetization / Paywall
  PaywallView = "paywall_view",
  PaywallCancelClick = "paywall_cancel_click",
  PaywallUpgradeClick = "paywall_upgrade_click",
  PaywallUpgradeReturn = "paywall_upgrade_return",
  PaywallCancelReturn = "paywall_cancel_return",
  FeatureGateBannerView = "feature_gate_banner_view",
  FeatureGateBannerUpgradeClick = "feature_gate_banner_upgrade_click",
}

export enum TrackedEventContext {
  FloatingBar = "floating_bar",
  Notes = "notes",
  InsertMenu = "insert_menu",
}

// Monetization contexts for paywall-related events
export type PaywallContext =
  | "note_create"
  | "note_mention_create"
  | "chat_message_send"
  | "note_list"
  | "collection_list"
  | "dark_mode_toggle";

// Tab Navigation Event Parameters
export interface PaneSplitEventParams {
  origin_pane_index: number;
}

export interface TabOpenEventParams {
  view_id: string;
  pane_index: number;
}

export interface TabViewEventParams {
  view_id: string;
  pane_index: number;
}
